import React, { useEffect } from 'react';

// import CheckedPurpleCircle from 'src/assets/app/checkedPurpleCircle.svg';
import classes from './benefitsQuoting.module.scss';

// const SectionTitle = (props) => {
//   const { title, subTitle } = props;

//   return (
//     <div className={classes.Section}>
//       <div className={classes.SectionSubTitle}>{subTitle}</div>
//       <div className={classes.SectionTitle}>{title}</div>
//     </div>
//   );
// };

// const SectionItem = (props) => {
//   const { title } = props;

//   return (
//     <span className={classes.SectionItem}>
//       <img src={CheckedPurpleCircle} alt="CheckedPurpleCircle" />
//       {title}
//     </span>
//   );
// };

export const BenefitsQuoting = () => {
  useEffect(() => {
    document.title = 'Monark | Benefits Quoting';
  }, []);

  return (
    <div id="benefits_quoting" className={classes.BenefitsQuoting}>
      <div className={classes.BenefitsQuotingSection}>
        <div className={classes.BenefitsQuotingLabel}>Quoting</div>
        <div className={classes.BenefitsQuotingTitle}>Enterprise Grade Quoting Platform</div>
        <div className={classes.BenefitsQuotingDescription}>
          Monark is the new benchmark in employee benefits quoting systems. Everyone can access the
          internet so why are proposals still sent as PDF's or excel files to be printed for
          meetings? (If you really love Excel, you can still export from Monark)
        </div>

        <div className={classes.BenefitsQuotingList}>
          <div className={classes.BenefitsQuotingListItem}>
            • Easily upload and update census files
          </div>
          <div className={classes.BenefitsQuotingListItem}>
            • Map employees to existing or new coverage options
          </div>
          <div className={classes.BenefitsQuotingListItem}>
            • Compare coverage options side by side
          </div>
          <div className={classes.BenefitsQuotingListItem}>• Model employer contributions</div>
          <div className={classes.BenefitsQuotingListItem}>
            • Instantly share live proposals with clients
          </div>
          <div className={classes.BenefitsQuotingListItem}>
            • Update in seconds and your client will already have the most current version
          </div>
          <div className={classes.BenefitsQuotingListItem}>
            • Have your clients click to confirm the desired quote and send the employer master
            information to the carrier instantly to begin implementation
          </div>
        </div>
      </div>
      <div className={classes.BenefitsQuotingSubsection}>
        <div className={classes.BenefitsQuotingSubsectionLabel}>Proposal</div>
        <div className={classes.BenefitsQuotingSubsectionTitle}>Proposal Management</div>
        <div className={classes.BenefitsQuotingSubsectionDescription}>
          With MonarkHQ you can share live updates to client quotes and proposals. Simply add the
          census information and click which plans you want to quote, map employer contribution as %
          or defined $, fixed or base plan modeling and then enter your clients email address to
          securely and instantly share the proposal. Want to make an edit as they are looking at it?
          No problem, simply update the proposal and hit save, as they refresh their page they will
          see the new options. All your clients, proposals and quotes are saved, searchable and can
          instantly be edited.
        </div>
        <div className={classes.BenefitsQuotingSubsectionDescription}>
          The best part? When your client decides on a quote, they can select it and instantly
          notify you to get things going!
        </div>
      </div>
    </div>
  );
};
